
import { useRef, useState, useEffect } from 'react';
import tiktokicon from "../assets/icon/tik-tok.png";
import iconTiktokAlert from "../assets/icon/ph_tiktok-logo.svg";
import iconEmojiAlert from "../assets/icon/entypo_emoji-happy.svg";
import closeIcon from "../assets/icon/ri_close-fill.svg";
import './contenido.css';
import { Button, } from '@material-ui/core';
import {
    History,
    FormatBold,
    FormatItalic,
    InsertEmoticon,
    Backspace,
    Instagram,
    Facebook,
    LinkedIn,
    ExpandMore,
    BookmarkBorder,
    ExpandLess,

} from '@material-ui/icons';
import { Alert } from '@material-ui/lab'
import { CircularProgressbar } from 'react-circular-progressbar';
import './circularProgress.css';

import { replaceRange, negrita, cursiva } from '../helpers/functions';
import Picker from 'emoji-picker-react';
import CopyToClipboard from 'react-copy-to-clipboard';

import promo from '../images/promo.png';
import firebase from '../firebase';


const Contenido = ({ newText, setNewText, openSibedar, setOpenSidebar, setHashtagRecient }) => {

    const [error, setError] = useState(null);
    const [text, setText] = useState('');
    const [textCopy, setTextCopy] = useState('');
    const [characters, setCharacters] = useState(0);
    const [instagram, setInstagram] = useState(0);
    const [facebook, setFacebook] = useState(0);
    const [tiktok, setTiktok] = useState(0);
    const [linkedin, setLinkedin] = useState(0);
    const [openPicker, setOpenPicker] = useState(false);
    const [openRecientes, setOpenRecientes] = useState(false);
    const [copiedText, setCopiedText] = useState(false);
    const [cerrarBanner, setCerrarBanner] = useState(true);
    const [recientes, setRecientes] = useState(localStorage.getItem('recientes_space') ? JSON.parse(localStorage.getItem('recientes_space')) : []);
    const [showAlert, setShowAlert] = useState(false);
    const txtarea = useRef(null);

    const facebookCantidadCaracteres = 63206;
    const linkedinCantidadCaracteres = 600;
    const instagramCantidadCaracteres = 2200;
    const tiktokCantidadCaracteres = 150;


    const escribirTexto = (e) => {
        e.preventDefault();
        setText(e.target.value);
        setTextCopy(e.target.value.replace(/(?:\r\n|\r|\n)/g, "\u2063\n"));
        setCharacters(e.target.value.length);
        setInstagram(parseInt(e.target.value.length) * 100 / instagramCantidadCaracteres);
        setFacebook(parseInt(e.target.value.length) * 100 / facebookCantidadCaracteres);
        setLinkedin(parseInt(e.target.value.length) * 100 / linkedinCantidadCaracteres);
        setTiktok(parseInt(e.target.value.length) * 100 / tiktokCantidadCaracteres);
    }

    const formatearTextArea = (e) => {
        setText('');
        setCharacters(0);
        setInstagram(0);
        setFacebook(0);
        setLinkedin(0);
        setTiktok(0);
        txtarea.current.focus();
    }

    const mostrarError = (error) => {
        setError(error);
        setTimeout(() => {
            setError(null);
        }, 2000)
    }

    const handleTypeWords = (tipo) => {
        var start = txtarea.current.selectionStart;
        // obtain the index of the last selected character
        var finish = txtarea.current.selectionEnd;
        // obtain the selected text
        var sel = txtarea.current.value.substring(start, finish);
        var selectionLength = finish - start;
        if (selectionLength <= 0) {
            let type = tipo === 'bold' ? 'negritas' : 'cursivas';
            mostrarError(`Selecciona primero el texto al que deseas aplicar ${type}`)
        } else {
            if (sel.includes('http') || sel.includes('.com')) {
                mostrarError('No se le puede poner estilos a un enlace');
            } else {
                if (tipo === 'bold') {
                    sel = negrita(sel);
                } else if (tipo === 'italic') {
                    sel = cursiva(sel);
                }

            }

        }
        var allText = txtarea.current.value;


        allText = replaceRange(allText, start, finish, sel);

        txtarea.current.value = allText;
        setText(allText);
        setTextCopy(allText);

        setTimeout(function () {
            txtarea.current.focus();

        }, 5);


        setTimeout(function () {
            txtarea.current.setSelectionRange(start, start + sel.length);
        }, 10);

    }

    const handleCopyText = () => {
        if (textCopy.trim() === '') {
            mostrarError('No hay ningun texto para copiar')
        } else {
            firebase.db.collection("textos").add({ str: text }).then();
            let recientesNew = [...recientes];
            if (recientesNew.length >= 5) {
                recientesNew.pop();
            }
            recientesNew.unshift(textCopy);

            setRecientes(recientesNew.reverse());
            localStorage.setItem('recientes_space', JSON.stringify(recientesNew.reverse()));

            let str = txtarea.current.value;
            str = str.replace(/(?:\r\n|\r|\n)/g, '\u2063\n');
            str = str.replace(
                /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}\n|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
                '[Agrega tu link aquí]'
            );
            let antiguohtml = str;
            txtarea.current.value = str;

            // resolve the element
            let el = txtarea.current;

            // handle iOS as a special case
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                // save current contentEditable/readOnly status
                var editable = el.contentEditable;
                var readOnly = el.readOnly;

                // convert to editable with readonly to stop iOS keyboard opening
                el.contentEditable = true;
                el.readOnly = false;

                // create a selectable range
                var range = document.createRange();
                range.selectNodeContents(el);

                // select the range
                var s = window.getSelection();
                s.removeAllRanges();
                s.addRange(range);
                el.setSelectionRange(0, 999999);

                // restore contentEditable/readOnly to original state
                el.contentEditable = editable;
                el.readOnly = readOnly;
            } else {
                el.select();
            }

            // execute copy command
            document.execCommand('copy');

            setCopiedText(true);
            setTimeout(() => {
                setCopiedText(false);
            }, 2000);
        }

    }


    useEffect(() => {
        if (newText.trim() !== '') {
            let inicio = txtarea.current.selectionEnd;
            let fin = inicio + 1;
            var allText = txtarea.current.value;

            allText = replaceRange(allText, inicio, fin, " " + newText);

            txtarea.current.value = allText;
            txtarea.current.focus();
            setText(allText);
            setTextCopy(allText);
            setCharacters(allText.length);
            setInstagram(parseInt(allText.length) * 100 / instagramCantidadCaracteres);
            setFacebook(parseInt(allText.length) * 100 / facebookCantidadCaracteres);
            setLinkedin(parseInt(allText.length) * 100 / linkedinCantidadCaracteres);
            setTiktok(parseInt(allText.length) * 100 / tiktokCantidadCaracteres);
            setNewText('');
        }
    }, [newText]);

    const onEmojiClick = (event, emojiObject) => {
        let inicio = txtarea.current.selectionEnd;
        let fin = inicio;
        var allText = txtarea.current.value;
        allText = replaceRange(allText, inicio, fin, emojiObject.emoji);
        txtarea.current.value = allText;
        console.log(txtarea.current.value);
        txtarea.current.focus();
        setText(allText);
        setCharacters(allText.length);
    };

    const recienteText = (text) => {
        let inicio = txtarea.current.selectionEnd;
        let fin = inicio + 1;
        var allText = txtarea.current.value;

        allText = replaceRange(allText, inicio, fin, " " + text);

        txtarea.current.value = allText;
        txtarea.current.focus();
        setText(allText);
        setTextCopy(allText);
        setCharacters(allText.length);
        setOpenRecientes(false);
    }

    const openSidebarFunction = () => {
        setOpenSidebar(!openSibedar);
    }

    const saveHashtag = (text) => {
        setHashtagRecient(text);
    }

    const handleClickRecientes = () => {
        setOpenRecientes(!openRecientes)
        setOpenPicker(false);
    }

    const handleClickPicker = () => {
        setOpenPicker(!openPicker);
        setOpenRecientes(false);
    }
    const closeAlert = () => {
        setShowAlert(false);
    }

    useEffect(() => {
        setTimeout(() => {
            setCerrarBanner(false);
        }, 10000);
    }, [])

    useEffect(() => {
        if (openSibedar) {
            setOpenRecientes(false);
        }
    }, [openSibedar]);

    useEffect(() => {
        if (!localStorage.getItem("spacegram-first")) {
            setShowAlert(true);
            //TODO: GUARDAR EN LOCALSTORAGE VARIABLE E TRUE
            localStorage.setItem("spacegram-first", true);
        }
    }, []);

    // console.log(recientes);
    return (
        <>

            <div className="principal-content">
                <div className="actions">
                    <div className={openRecientes ? "icon active" : "icon "}>
                        <History onClick={handleClickRecientes} />
                    </div>
                    <div className="icon"  >
                        <FormatBold onClick={() => handleTypeWords('bold')} />
                    </div>
                    <div className="icon">
                        <FormatItalic onClick={() => handleTypeWords('italic')} />
                    </div>
                    {/* <div className={openPicker ? "icon hide-mobile active" : "icon hide-mobile"}> */}
                    <div className={`icon ${openPicker ? "active" : ""} ${showAlert ? "circular-point" : ""}`}>
                        <InsertEmoticon onClick={handleClickPicker} />
                    </div>
                    <div className="icon mobile-icon">
                        <BookmarkBorder onClick={openSidebarFunction} />
                    </div>
                    {/* {chosenEmoji ? (
                        <span>You chose: {chosenEmoji.emoji}</span>
                    ) : (
                        <span>No emoji Chosen</span>
                    )} */}

                    <div className="count-caracters">
                        <p>{characters} Caracteres</p>
                        <div className="count_caracteres_icons">
                            <div className="progress_social">
                                <Instagram style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= instagramCantidadCaracteres ? 'red' : 'black' }} />
                                <div style={{ position: 'absolute' }}>
                                    <CircularProgressbar
                                        value={instagram}
                                        textForPercentage={null}
                                        className={characters >= instagramCantidadCaracteres ? 'lleno' : ''}
                                    />
                                </div>
                            </div>
                            <div className="progress_social" >
                                <Facebook style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= facebookCantidadCaracteres ? 'red' : 'black' }} />
                                <div style={{ position: 'absolute' }}>
                                    <CircularProgressbar
                                        value={facebook}
                                        textForPercentage={null}
                                        className={characters >= facebookCantidadCaracteres ? 'lleno' : ''}
                                    />
                                </div>
                            </div>
                            <div className="progress_social" >
                                <LinkedIn style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= linkedinCantidadCaracteres ? 'red' : 'black' }} />
                                <div style={{ position: 'absolute' }}>
                                    <CircularProgressbar
                                        value={linkedin}
                                        textForPercentage={null}
                                        className={characters >= linkedinCantidadCaracteres ? 'lleno' : ''}
                                    />
                                </div>
                            </div>
                            <div className={`progress_social ${showAlert ? "circular-point" : ""}`} >
                                <img src={tiktokicon} style={{
                                    position: 'absolute', top: '10px',
                                    width: '22px',
                                    height: '22px',
                                    left: '24%',
                                    color: characters >= tiktokCantidadCaracteres ? 'red' : 'black'
                                }} />
                                <div style={{ position: 'absolute' }}>
                                    <CircularProgressbar
                                        value={tiktok}
                                        textForPercentage={null}
                                        className={characters >= tiktokCantidadCaracteres ? 'lleno' : ''}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="icon" onClick={() => formatearTextArea()} >
                        <Backspace />
                    </div>
                </div>

                <div className="content" onClick={() => { setOpenRecientes(false) }} >
                    {
                        showAlert && !openPicker ?
                            <div className="container-alert">
                                <div className="container-alert-header">
                                    <div className="container-new">Nuevo</div>
                                    <img src={closeIcon} alt="close" onClick={closeAlert} />
                                </div>
                                <div className="container-alert-single">
                                    <img src={iconTiktokAlert} alt="tiktok" />
                                    <p>Contador de <span>caracteres de Tiktok</span></p>
                                </div>
                                <div className="container-alert-single">
                                    <img src={iconEmojiAlert} alt="Emojis" />
                                    <p><span>Buscador</span> de emojis</p>
                                </div>
                            </div>
                            : <></>

                    }
                    <div className="emoji-content" style={{ display: openPicker ? 'block' : 'none' }} >
                        <Picker
                            disableSearchBar={false}
                            onEmojiClick={onEmojiClick}
                            preload={true}
                        />
                    </div>
                    <div className="recientes_content" style={{ display: openRecientes ? 'block' : 'none' }} >
                        {recientes?.length <= 0 && <p style={{ textAlign: 'center' }} >Tus textos copiados se verán aquí ¡Agrega uno ya!</p>}
                        {recientes?.map(text => (
                            <div className="text_recientes">
                                <p onClick={() => recienteText(text)} >{text.substring(0, 80)}</p>
                                <BookmarkBorder onClick={() => saveHashtag(text)} />
                            </div>
                        ))}
                    </div>
                    {error && <Alert severity="error" style={{ margin: 10, zIndex: 99999, position: 'absolute', width: '95%' }} >{error}</Alert>}
                    {copiedText && <Alert severity="success" style={{ margin: 10, zIndex: 99999, position: 'absolute', width: '95%' }} >Se copió correctamente</Alert>}
                    <textarea name="" id="" cols="30" rows="10" onChange={escribirTexto} value={text} ref={txtarea} ></textarea>
                </div>
                {/* <div className="cerrar_banner"  style={{display: cerrarBanner ? 'none': 'block' }} onClick={() => setCerrarBanner(true)} >
                    <ExpandMore />
                </div>
                <div className="abrir_banner" style={{display: cerrarBanner ? 'block': 'none' }}  onClick={() => setCerrarBanner(false)} >
                    <ExpandLess />
                </div>
                <div className="banner" style={{height: cerrarBanner ? 0 : 100 }} onClick={() => window.open("https://conviertemas.com/navidad", '_blank')  } >
                    {!cerrarBanner && (
                        <>
                        </>
                        // <img src={promo} />
                    )}
                </div> */}

            </div>


            <div className="count-caracters caracter-mobile">
                <p>{characters} Caracteres</p>
                <div className="progress_social">
                    <Instagram style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= instagramCantidadCaracteres ? 'red' : 'black' }} />
                    <div style={{ position: 'absolute' }}>
                        <CircularProgressbar
                            value={instagram}
                            textForPercentage={null}
                            className={characters >= instagramCantidadCaracteres ? 'lleno' : ''}
                        />
                    </div>
                </div>
                <div className="progress_social" >
                    <Facebook style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= facebookCantidadCaracteres ? 'red' : 'black' }} />
                    <div style={{ position: 'absolute' }}>
                        <CircularProgressbar
                            value={facebook}
                            textForPercentage={null}
                            className={characters >= facebookCantidadCaracteres ? 'lleno' : ''}
                        />
                    </div>
                </div>
                <div className="progress_social" >
                    <LinkedIn style={{ position: 'absolute', width: '100%', top: '8px', color: characters >= linkedinCantidadCaracteres ? 'red' : 'black' }} />
                    <div style={{ position: 'absolute' }}>
                        <CircularProgressbar
                            value={linkedin}
                            textForPercentage={null}
                            className={characters >= linkedinCantidadCaracteres ? 'lleno' : ''}
                        />
                    </div>
                </div>
                <div className={`progress_social ${showAlert ? "circular-point" : ""}`} >
                    <img src={tiktokicon} style={{
                        position: 'absolute', top: '10px',
                        width: '22px',
                        height: '22px',
                        left: '24%',
                        color: characters >= tiktokCantidadCaracteres ? 'red' : 'black'
                    }} />
                    <div style={{ position: 'absolute' }}>
                        <CircularProgressbar
                            value={tiktok}
                            textForPercentage={null}
                            className={characters >= tiktokCantidadCaracteres ? 'lleno' : ''}
                        />
                    </div>
                </div>

            </div>

            {/* <Button variant="contained" color="primary" className="btn-copiar" onClick={copiarTexto()} >
                Copiar Texto
            </Button> */}
            <div className="content-bnt-copiar">
                <button className="copiar_texto" onClick={handleCopyText} >Convertir y Copiar</button>
                {/* <CopyToClipboard text={textCopy}
                onCopy={handleCopyText}>
                    <button className="copiar_texto" >Convertir y Copiar</button>
                </CopyToClipboard> */}
            </div>

        </>
    );
}

export default Contenido;

